import type { User } from 'src/features/auth';
import type { Parking } from 'src/features/parkingManagement/types/parking';
import type { BaseModel } from 'src/types/models';

export interface Membership extends BaseModel {
    user: User;
    status: string;
    role: MEMBERSHIP_ROLES;
    parking: string;
    smartpark_id: string;
    guest_reasons: [];
}

export interface UserMembership extends Omit<Membership, 'parking'> {
    parking: Parking;
}

export enum ALLOWED_VALIDATION {
    GUEST = 'guest',
    PRICING_PLAN = 'pricing-plan',
}

export enum MEMBERSHIP_ROLES {
    OPERATOR = 'parking_operator',
    OWNER = 'parking_owner',
    VIEWER = 'parking_viewer',
    CLIENT = 'parking_client',
    VALIDATOR = 'parking_validator',
    FINANCE = 'parking_finance',
    PARKING_MANAGER = 'parking_manager',
    RECEPTION = 'reception',
    RECEPTION_MANAGER = 'reception_manager',
    SALES_MANAGER = 'sales_manager',
    UBB_RESERVATIONS = 'ubb_reservations',
}
